(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["global-timer-banner"] && !Shopify.designMode) return;
  try {
    
  const setTimer = () => {
    const dom = document.querySelectorAll('#global-timer-banner-counter');

    dom.forEach((element) => {
      if (!element) {
        return false;
      }

      const future = Date.parse(element.dataset.endDate);
      let now = Date.parse(
        new Date().toLocaleString('en-US', { timeZone: 'America/Chicago' })
      );
      let difference = future - now;

      let days = Math.floor(difference / (1000 * 60 * 60 * 24));
      let hours = Math.floor(difference / (1000 * 60 * 60));
      let mins = Math.floor(difference / (1000 * 60));
      let secs = Math.floor(difference / 1000);

      let d = days;
      let h = hours - days * 24;
      let m = mins - hours * 60;
      let s = secs - mins * 60;

      element.innerHTML =
        '<span class="me-2">' +
        d +
        '<span>d</span></span>' +
        '<span class="me-2">' +
        h +
        '<span>h</span></span>' +
        '<span class="me-2">' +
        m +
        '<span>m</span></span>' +
        '<span>' +
        s +
        '<span>s</span></span>';
    })

  };

  setInterval(setTimer, 1000);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["timer-banner"] && !Shopify.designMode) return;
  try {
    

    const bannerWrapperClass = document.querySelector('.timer-banner');
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    const bfParam = 'bf-starter-bundle';
    const isDaniBundle = bannerWrapperClass.classList.contains('dani-bundle');

    if ((params.utm_campaign && params.utm_campaign == bfParam) || isDaniBundle) {
       bannerWrapperClass.style.display = 'block'; 
    }

    const setTimer = () => {
      
      const element = document.getElementById('timer-banner');
      const future = Date.parse("nov 25, 2022 23:59:59");
      let now = Date.parse(new Date().toLocaleString("en-US", { timeZone: "America/Chicago" }));
      let difference = future - now;
    
      let days = Math.floor(difference / (1000 * 60 * 60 * 24));
      let hours = Math.floor(difference / (1000 * 60 * 60));
      let mins = Math.floor(difference / (1000 * 60));
      let secs = Math.floor(difference / 1000);
    
      let d = days;
      let h = hours - days * 24;
      let m = mins - hours * 60;
      let s = secs - mins * 60;

      element.innerHTML =
          '<div>' + d + '<span> days<span class="punctuation">, </span></span></div>' +
          '<div>' + h + '<span> hours<span class="punctuation">, </span></span></div>' +
          '<div>' + m + '<span> minutes<span class="punctuation">, </span><span class="punctuation"></div>' +
          '<div>' + s + '<span> seconds<span class="punctuation">.</span><span class="punctuation"></div>';
    }

    setInterval(setTimer, 1000);
  

  } catch(e) { console.error(e); }
})();
})();
